import { TableRowPropertiesLeafElementDestination } from './table-row-properties-leaf-element-destination';
export class TableRowConditionalFormattingDestination extends TableRowPropertiesLeafElementDestination {
}
